import { saveAs } from "file-saver";

const getLogoUrl = (logoPath) => {
  if (!logoPath) return null;
  if (/^https?:\/\//i.test(logoPath)) return logoPath;
  let normalized = String(logoPath).replace(/\\/g, "/");
  normalized = normalized.replace(/^[Cc]:\/Dokumenta\//i, "");
  normalized = normalized.replace(/^\/+/, "");
  return `${process.env.REACT_APP_BACKEND_URL}/files/${encodeURI(normalized)}`;
};

function amountToSerbianWords(amount) {
  if (amount === null || amount === undefined || amount === "") return "";
  const n = Number(String(amount).replace(",", "."));
  if (Number.isNaN(n)) return "";
  const din = Math.floor(Math.abs(n));
  const para = Math.round((Math.abs(n) - din) * 100);
  const ones = ["nula","jedan","dva","tri","četiri","pet","šest","sedam","osam","devet","deset","jedanaest","dvanaest","trinaest","četrnaest","petnaest","šesnaest","sedamnaest","osamnaest","devetnaest"];
  const tens = ["","","dvadeset","trideset","četrdeset","pedeset","šezdeset","sedamdeset","osamdeset","devedeset"];
  const hundreds = ["","sto","dvesta","trista","četiristo","petsto","šeststo","sedamsto","osamsto","devetsto"];
  function twoDigits(x) {
    if (x < 20) return ones[x];
    return (tens[Math.floor(x / 10)] + (x % 10 ? ones[x % 10] : "")).trim();
  }
  function threeDigits(x) {
    if (x === 0) return "";
    if (x < 100) return twoDigits(x);
    return (hundreds[Math.floor(x / 100)] + (x % 100 ? twoDigits(x % 100) : "")).trim();
  }
  function toWords(x) {
    if (x === 0) return "nula";
    const mil = Math.floor(x / 1000000);
    const th = Math.floor((x % 1000000) / 1000);
    const rem = x % 1000;
    const parts = [];
    if (mil) parts.push(mil === 1 ? "milion" : threeDigits(mil) + "miliona");
    if (th)  parts.push(th === 1 ? "hiljadu" : threeDigits(th) + "hiljada");
    if (rem) parts.push(threeDigits(rem));
    return parts.join("").trim();
  }
  const dinarWord = din === 1 ? "dinar" : "dinara";
  let out = toWords(din) + dinarWord;
  if (para > 0) out += "i" + toWords(para) + "para";
  return n < 0 ? "minus" + out : out;
}

async function urlToBase64(url, token) {
  const headers = token ? { Authorization: "Bearer " + token } : {};
  const res = await fetch(url, { headers });
  if (!res.ok) return null;
  const blob = await res.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = () => resolve(null);
    reader.readAsDataURL(blob);
  });
}

async function processHtml(podaci, token) {
  let html = podaci.htmlContent;

  const logoUrl = getLogoUrl(podaci.logoPath);
  if (logoUrl) {
    // Konvertuj logo u base64 da Puppeteer ne mora da pravi mrežne zahteve
    const logoBase64 = await urlToBase64(logoUrl, token).catch(() => null);
    if (logoBase64) {
      html = html.replace("{{LOGO_URL}}", logoBase64);
    } else {
      html = html.replace('<img alt="Logo" src="{{LOGO_URL}}">', "");
    }
  } else {
    html = html.replace('<img alt="Logo" src="{{LOGO_URL}}">', "");
  }

  if (html.includes("{{SLOVIMA}}")) {
    const rsdAmount = (podaci.UkupnoZaNaplatu ?? 0) * (podaci.Kurs ?? 1);
    html = html.replace("{{SLOVIMA}}", amountToSerbianWords(rsdAmount));
  }

  return html;
}

export async function exportInvoiceHtmlToPdfBytes(podaci, token) {
  const html = await processHtml(podaci, token);

  const res = await fetch(
    `${process.env.REACT_APP_BACKEND_URL}/invoice/HtmlToPdf`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: "Bearer " + token } : {}),
      },
      body: JSON.stringify({ html }),
    }
  );

  if (!res.ok) {
    const msg = await res.text().catch(() => res.status);
    throw new Error("HtmlToPdf greška: " + msg);
  }

  return await res.arrayBuffer();
}

export async function exportInvoiceHtmlToPdf(podaci, token, fileName = "Faktura.pdf") {
  const arrayBuffer = await exportInvoiceHtmlToPdfBytes(podaci, token);
  saveAs(new Blob([arrayBuffer], { type: "application/pdf" }), fileName);
}
